import { createAction, props } from '@ngrx/store';
import { DownloadRegistryUnit } from '../reducers';

export const setSelectedTextbook = createAction(
  '[Selected-Textbook] set textbook',
  props<{ textbook: DownloadRegistryUnit | null; isOutdated?: boolean }>()
);
